import { t } from "i18next";
import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Typeahead } from "react-bootstrap-typeahead";

export default function CourseFilter(props: any) {
  const { t, i18n } = useTranslation("common");
  const { showInstructor, filterValues, setFilterValues, teachers } = props;

  const setField = (field: string, value: string) => {
    setFilterValues({
      ...filterValues,
      [field]: value,
    });
  };

  // Teachers kommen jetzt bereits sortiert vom Backend als Array
  const myTeachers: any = Array.isArray(teachers) ? teachers : [];

  // Find selected teacher object for Typeahead
  const selectedTeacher = myTeachers.find((t: any) => t.id === filterValues.teacher);
  const selectedTeachers = selectedTeacher ? [selectedTeacher] : [];
  return (
    <div style={{ maxWidth: "600px" }}>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label>{t('search.globalLabel')}</Form.Label>
          <Form.Control
            type="text"
            value={filterValues.title}
            name="title"
            placeholder={t('search.inputPlaceholder')}
            onChange={(e) => setField("title", e.target.value)}
          />
        </Form.Group>
        {!!showInstructor && (
          <Form.Group as={Col}>
            <Form.Label>{t('courseForm.teacherLabel')}</Form.Label>
            <Typeahead
              id="courseFilter.teacher"
              labelKey="name"
              onChange={(selected: any[]) => {
                setField("teacher", selected.length > 0 ? selected[0].id : "");
              }}
              options={myTeachers}
              placeholder={t('search.showAllLabel')}
              selected={selectedTeachers}
              clearButton
            />
          </Form.Group>
        )}
      </Row>
    </div>
  );
}
